import * as lodash from 'lodash'
export default lodash
